module.exports = __webpack_public_path__ + "static/media/shareLockGuide5_Jap.53343014.jpg";